import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { AddFromOtherEventModel } from '@app/v2/event/types/add-from-other-event.model'
import { ModalComponent } from '@app/v2/shared/components/modal/modal.component'

export type AddEntriesMethod = 'other-event' | 'file'

type AddEntriesMethodCard = {
  id: AddEntriesMethod
  title: string
  description: string
}

const ADD_ENTRIES_METHOD_CARDS: AddEntriesMethodCard[] = [
  { id: 'other-event', title: 'From other event', description: 'Reuse entries from other event.' },
  { id: 'file', title: 'Import from a file', description: 'Add entries in bulk using an existing file.' }
]

@Component({
  selector: 'app-add-entries-method-modal',
  standalone: true,
  imports: [ModalComponent],
  templateUrl: './add-entries-method-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddEntriesMethodModalComponent {
  public readonly id = input.required<string>()
  public readonly personaName = input<string>('')

  public readonly methodSelected = output<AddEntriesMethod>()

  public readonly cards = ADD_ENTRIES_METHOD_CARDS
  public readonly headerIcon = AddFromOtherEventModel.HEADER_PLUS_ICON
  public readonly header = computed(() => `Add ${this.personaName().toUpperCase()}`.trim())

  /**
   * Notifies the parent which adding method was picked.
   * @param card - Selected method card.
   */
  public onCardClick(card: AddEntriesMethodCard): void {
    this.methodSelected.emit(card.id)
  }
}
